export const CitationCommonStyle = {
  card: {
    width: '100%',
    borderRadius: { xs: '8px', sm: '12px' },
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    padding: '24px',
  },
  // Typography
  typography: {
    primaryText: {
      fontFamily: 'Inter',
      color: 'var(--color-primary)'
    },
    headingLarge: {
      fontFamily: 'Inter',
      fontWeight: 700,
      fontSize: { xs: '20px', sm: '24px', md: '30px' },
      lineHeight: { xs: '28px', sm: '32px', md: '38px' },
      color: 'var(--color-primary)'
    },
    headingMedium: {
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSize: { xs: '20px', sm: '24px' },
      lineHeight: { xs: '28px', sm: '32px' },
      color: 'var(--color-primary)'
    },
    bodyMedium: {
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSize: { xs: '14px', sm: '14px' },
      lineHeight: { xs: '20px', sm: '20px' },
      color: 'var(--color-primary)'
    },
    tooltipText: {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 500,
      lineHeight: 'var(--line-height-18)',
      textAlign: 'left',
      color: 'var(--color-primary)'
    }
  },
  // Icons
  icons: {
    helpIcon: {
      width: '25px',
      height: '25px',
      color: 'rgba(168, 166, 191, 1)',
      '&:hover': {
        color: 'var(--color-primary)'
      }
    }
  },
  // Layout
  layout: {
    flexRowCenter: {
      display: 'flex',
      alignItems: 'center',
      gap: { xs: '8px', sm: '12px' }
    }
  },
  // Components
  components: {
    switch: {
      width: '48px',
      height: '26px',
      padding: 0,
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: '3px',
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(22px)',
          color: 'var(--color-white)',
          '& + .MuiSwitch-track': {
            backgroundColor: 'var(--color-primary)',
            opacity: 1,
            border: 0
          }
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: 'var(--color-primary)',
          border: '4px solid var(--color-white)'
        }
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: '20px',
        height: '20px'
      },
      '& .MuiSwitch-track': {
        borderRadius: '13px',
        backgroundColor: 'var(--color-bg-mid-grey)',
        opacity: 1,
        transition: 'background-color 300ms'
      }
    },
    borderedContainer: {
      border: '1px solid var(--color-text-muted-purple)',
      borderRadius: '6px',
      padding: { xs: '8px 12px', sm: '10px 16px' },
      display: 'flex',
      alignItems: 'center',
      gap: { xs: '8px', sm: '12px' }
    }
  }
};
